import { Link } from 'react-router-dom';
import { Moon, Sun } from '@phosphor-icons/react';
import { FOOTER_LINK_GROUPS, LATTED_TAGLINE } from './landingContent';

function LandingFooter({ logoSrc, isDark, onToggleTheme, onSignIn, onCreateVideo }) {
  const year = new Date().getFullYear();

  const renderItem = (item) => {
    if (item.href) {
      return (
        <Link to={item.href} className="lp-footer__link lp-focusable">
          {item.label}
        </Link>
      );
    }
    const handler = item.action === 'sign-in' ? onSignIn : onCreateVideo;
    return (
      <button
        type="button"
        className="lp-footer__link lp-focusable"
        onClick={() => handler('footer')}
      >
        {item.label}
      </button>
    );
  };

  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer__top">
          <div className="lp-footer__brand">
            <Link to="/" className="lp-focusable" aria-label="Latted home">
              <img src={logoSrc} alt="Latted" />
            </Link>
            <p className="lp-footer__tagline">{LATTED_TAGLINE}</p>
          </div>

          {FOOTER_LINK_GROUPS.map((group) => (
            <nav className="lp-footer__group" key={group.id} aria-label={group.title}>
              <h2 className="lp-footer__group-title">{group.title}</h2>
              <ul className="lp-footer__links">
                {group.links.map((item) => (
                  <li key={item.label}>{renderItem(item)}</li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="lp-footer__bottom">
          <p className="lp-footer__copyright">© {year} Latted. All rights reserved.</p>
          <div className="lp-footer__theme">
            <span>{isDark ? 'Dark' : 'Light'} theme</span>
            <button
              type="button"
              className="lp-icon-btn lp-focusable"
              onClick={() => onToggleTheme(isDark ? 'light' : 'dark')}
              aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
            >
              {isDark ? <Sun size={16} /> : <Moon size={16} />}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
